import { getLookupFromLocalStorage } from '@/modules/complaints/helpers/utils';

export default {
  complaintStatuses: getLookupFromLocalStorage('complaintStatuses'),
  complaintCategories: getLookupFromLocalStorage('complaintCategories'),
};
